import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const QuestionaireApi = createApi(config.QUESTIONAIRE_API_URL);

export default QuestionaireApi;
